export const timeZones = ['IST', 'ET', 'CT', 'MT', 'PT'] as const;

export type SupportedTimeZone = (typeof timeZones)[number];

export const timeZoneLabels: Record<SupportedTimeZone, string> = {
  IST: 'India Standard Time',
  ET: 'Eastern Time',
  CT: 'Central Time',
  MT: 'Mountain Time',
  PT: 'Pacific Time',
};
